import Home from '../pages/admin/Home';
import ManageMenu from '../pages/admin/ManageMenu';
import ManageTable from '../pages/admin/ManageTable';
import AddUser from '../pages/admin/AddUser';
import AddUnit from '../pages/admin/AddUnit';
import Payments from '../pages/admin/Payments';
import Orders from '../pages/admin/Orders';
import AddGst from '../pages/admin/AddGst';
import AddPriceCategory from '../pages/admin/AddPriceCategory';
import AddServiceArea from '../pages/admin/AddServiceArea';
import AddCategory from '../pages/admin/AddCategory';
import SalesSummary from '../pages/admin/Reports/SalesSummary';
import SalesDetails from '../pages/admin/Reports/SalesDetails';
import Collection from '../pages/admin/Reports/Collection';
import Preferences from '../pages/admin/Preferences';
import ItemWiseDetails from '../pages/admin/Reports/ItemWiseDetails';

const AdminRoutes = [
  { path: '/admin', element: <Home />, exact: true },
  { path: '/admin/home', element: <Home />, exact: true },
  { path: '/admin/add-unit', element: <AddUnit />, exact: true },
  { path: '/admin/options', element: <Preferences />, exact: true },
  { path: '/admin/add-category', element: <AddCategory />, exact: true },
  { path: '/admin/service-areas', element: <AddServiceArea />, exact: true },
  { path: '/admin/add-price-category', element: <AddPriceCategory />, exact: true },
  { path: '/admin/tables', element: <ManageTable />, exact: true },
  { path: '/admin/menu', element: <ManageMenu />, exact: true },
  { path: '/admin/orders', element: <Orders />, exact: true },
  { path: '/admin/payments', element: <Payments />, exact: true },
  { path: '/admin/add-user', element: <AddUser />, exact: true },
  { path: '/admin/gst', element: <AddGst />, exact: true },
  { path: '/admin/reports/sales-summary', element: <SalesSummary />, exact: true },
  { path: '/admin/reports/sales-details', element: <SalesDetails />, exact: true },
  { path: '/admin/reports/item-wise-details', element: <ItemWiseDetails />, exact: true },
  { path: '/admin/reports/collection', element: <Collection />, exact: true },
];

export default AdminRoutes;